(function () {
  'use strict';

  var INIT = 'data-lp-referral-init';
  var EASE_MS = 450;

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function scrollToTarget(root, selector) {
    if (!selector) return;
    var target = root.querySelector(selector);
    if (!target) return;
    target.scrollIntoView({
      behavior: reducedMotion() ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  function initScrollControls(root) {
    root.querySelectorAll('[data-lp-referral-scroll]').forEach(function (btn) {
      if (btn.getAttribute('data-lp-referral-scroll-bound') === 'true') return;
      btn.setAttribute('data-lp-referral-scroll-bound', 'true');
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        scrollToTarget(root, btn.getAttribute('data-lp-referral-scroll'));
      });
    });
  }

  function initHero(root) {
    var hero = root.querySelector('[data-lp-referral-hero]');
    if (!hero || hero.getAttribute('data-lp-referral-hero-bound') === 'true') return;
    hero.setAttribute('data-lp-referral-hero-bound', 'true');

    function revealHero() {
      hero.classList.add('is-inview');
    }

    if (reducedMotion()) {
      revealHero();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          revealHero();
        } else {
          hero.classList.remove('is-inview');
        }
      });
    }, { threshold: 0.25 });

    io.observe(hero);

    var parallaxWrap = hero.querySelector('[data-lp-referral-parallax]');
    if (!parallaxWrap) return;

    var ticking = false;

    function updateParallax() {
      ticking = false;
      var rect = hero.getBoundingClientRect();
      var viewH = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom < 0 || rect.top > viewH) return;

      var progress = 1 - Math.min(Math.max((rect.bottom - viewH * 0.2) / (rect.height + viewH * 0.2), 0), 1);
      var offset = progress * 4;
      parallaxWrap.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateParallax);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateParallax();
  }

  function initRewards(root) {
    var section = root.querySelector('[data-lp-referral-rewards]');
    if (!section || section.getAttribute('data-lp-referral-rewards-bound') === 'true') return;
    section.setAttribute('data-lp-referral-rewards-bound', 'true');

    var doneTimer = null;

    function setActive(active) {
      if (active) {
        section.classList.add('is-lines-active');
        if (doneTimer) window.clearTimeout(doneTimer);
        doneTimer = window.setTimeout(function () {
          section.classList.add('is-lines-done');
        }, reducedMotion() ? 0 : EASE_MS);
      } else {
        section.classList.remove('is-lines-active');
        section.classList.remove('is-lines-done');
        if (doneTimer) {
          window.clearTimeout(doneTimer);
          doneTimer = null;
        }
      }
    }

    if (reducedMotion()) {
      setActive(true);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        setActive(entry.isIntersecting);
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });

    io.observe(section);
  }

  function initSteps(root) {
    var section = root.querySelector('[data-lp-referral-steps]');
    if (!section || section.getAttribute('data-lp-referral-steps-bound') === 'true') return;
    section.setAttribute('data-lp-referral-steps-bound', 'true');

    var steps = section.querySelectorAll('[data-lp-referral-step]');
    if (!steps.length) return;

    function activate(active) {
      if (active) {
        section.classList.add('is-progress-active');
        steps.forEach(function (step, index) {
          window.setTimeout(function () {
            step.classList.add('is-active');
          }, reducedMotion() ? 0 : index * 120);
        });
      } else {
        section.classList.remove('is-progress-active');
        steps.forEach(function (step) {
          step.classList.remove('is-active');
        });
      }
    }

    if (reducedMotion()) {
      activate(true);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        activate(entry.isIntersecting);
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -10% 0px' });

    io.observe(section);
  }

  function initFaq(root) {
    var items = root.querySelectorAll('[data-lp-referral-faq-item]');
    items.forEach(function (item) {
      if (item.getAttribute('data-lp-referral-faq-bound') === 'true') return;
      item.setAttribute('data-lp-referral-faq-bound', 'true');

      var trigger = item.querySelector('[data-lp-referral-faq-trigger]');
      var panel = item.querySelector('[data-lp-referral-faq-panel]');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');

        if (willOpen) {
          items.forEach(function (other) {
            if (other === item) return;
            other.classList.remove('is-open');
            var otherTrigger = other.querySelector('[data-lp-referral-faq-trigger]');
            var otherPanel = other.querySelector('[data-lp-referral-faq-panel]');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.hidden = true;
          });
        }

        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        panel.hidden = !willOpen;
      });
    });
  }

  function clearBindings(root) {
    root.removeAttribute(INIT);
    root.querySelectorAll('[data-lp-referral-scroll-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-referral-scroll-bound');
    });
    root.querySelectorAll('[data-lp-referral-hero-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-referral-hero-bound');
    });
    root.querySelectorAll('[data-lp-referral-rewards-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-referral-rewards-bound');
    });
    root.querySelectorAll('[data-lp-referral-steps-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-referral-steps-bound');
    });
    root.querySelectorAll('[data-lp-referral-faq-bound]').forEach(function (el) {
      el.removeAttribute('data-lp-referral-faq-bound');
    });
  }

  function initSection(root) {
    if (!root || root.getAttribute(INIT) === 'true') return;
    root.setAttribute(INIT, 'true');
    initScrollControls(root);
    initHero(root);
    initRewards(root);
    initSteps(root);
    initFaq(root);
  }

  function boot() {
    document.querySelectorAll('[data-lp-referral]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-lp-referral]');
    if (!root) return;
    clearBindings(root);
    initSection(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-lp-referral]');
    if (root) clearBindings(root);
  });
})();
